module.exports = __webpack_public_path__ + "img/logo_5_propagas.c2bb0ca6.png";